<template>
  <v-container fluid :class="fillBackgroundClasses">
    <v-row justify="center" no-gutters>
      <v-col xs="12" md="7">
        <signing-wizard />
      </v-col>
    </v-row>
    <v-row justify="center" no-gutters>
      <v-col xs="1" md="1">
        <version-tag></version-tag>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { panelData, footerData, appThemeData } from '@/store/helpers'
import { signingWizardActions } from '@/modules/signers/store/signingWizardStoreHelpers'
import { fielStorageActions } from '@/modules/signers/store/fielStorageHelpers'
import ConvertToken from '@/utils/ConvertToken'

import SigningWizard from '@/modules/signers/components/SigningWizard'

export default {
  name: 'SigningPage',
  created() {
    this.closeWizard()
    this.$nextTick(() => {
      this.checkToken()
    })
  },
  components: {
    SigningWizard
  },
  computed: {
    ...appThemeData,
    ...panelData,
    ...footerData,
    fillBackgroundClasses: {
      get() {
        return `fill-height ${this.appThemeBackgroundWelcome}`
      }
    }
  },
  methods: {
    ...signingWizardActions,
    ...fielStorageActions,
    checkToken() {
      if (this.$route.query.token !== undefined) {
        const convert = new ConvertToken()
        const tokenJson = convert.parseJwt(this.$route.query.token)

        if (
          tokenJson.identity.documentId !== undefined &&
          tokenJson.identity.signerId !== undefined &&
          tokenJson.identity.signerRFC !== undefined
        ) {
          this.setTokenWizard(this.$route.query.token)
          this.setDocumentWizard(tokenJson.identity.documentId)
          this.setSignerWizard(tokenJson.identity.signerId)
          this.setFielRfcToCompare(tokenJson.identity.signerRFC)

          this.openWizard()
        } else {
          this.goHome()
        }
      } else {
        this.goHome()
      }
    },
    goHome() {
      this.$router.push('/dashboard')
    }
  }
}
</script>
